module.exports = __webpack_public_path__ + "static/media/savio1.30aaea8a.jpg";